export default __webpack_public_path__ + "static/media/Logotransparente.dc19dc45.png";